import {type FunctionComponent} from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {RootLoaderResponse} from '../../../types/index.js'
import {getTranslation} from '../../../localization/translation.js'
import {getConfiguration} from '../../../utils/configuration/configuration.js'

export const PopularCategories: FunctionComponent = () => {
  const {locale, language, deviceType} = useRouteLoaderData('root') as RootLoaderResponse
  const {popularCategories} = getConfiguration(locale)
  const translations = getTranslation(language)
  const device = deviceType === 'smartphone' ? 'mobile' : 'desktop'

  return (
    popularCategories && (
      <section className="flex w-full flex-col justify-center">
        <p className="mt-5 pb-8 text-center text-2xl font-medium leading-snug">
          {translations.PopularCategories.title}
        </p>
        <div className="row-auto grid grid-cols-4 gap-4 desktop:gap-6 tablet:grid-cols-2 tablet:gap-20 mobile:gap-6">
          {popularCategories({device}).map((category, index) => {
            return (
              <div key={`${category.title}-${index}`} className="flex flex-col">
                <div className="relative flex w-full items-center justify-center bg-neutral-50 desktop:h-56 tablet:h-80 mobile:h-48">
                  <img
                    src={category.image}
                    loading="lazy"
                    alt={category.title}
                    className="m-w-[90%] m-h-[90%] h-[90%] w-[90%] object-contain mix-blend-darken"
                  />
                </div>
                <p className="mb-4 mt-4 w-full overflow-hidden text-ellipsis whitespace-nowrap text-lg font-semibold">
                  {category.title}
                </p>
                {category.categories.map((category, index) => {
                  return (
                    <a
                      key={`${category.title}-${index}`}
                      href={category.href}
                      className="mb-3"
                      aria-label={`go to ${category.title}`}
                    >
                      {category.title}
                    </a>
                  )
                })}
              </div>
            )
          })}
        </div>
      </section>
    )
  )
}
